import { render, staticRenderFns } from "./CplateTerminal.vue?vue&type=template&id=ec425ef8&scoped=true"
import script from "./CplateTerminal.vue?vue&type=script&lang=js"
export * from "./CplateTerminal.vue?vue&type=script&lang=js"
import style0 from "./CplateTerminal.vue?vue&type=style&index=0&id=ec425ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec425ef8",
  null
  
)

export default component.exports